// ProtectedRoute: restricts access based on authentication and optional role
// import React, { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ role }) {
  const { isAuthenticated, isAdmin, isLoading } = useAuth();

  // ✅ Attendre que le chargement soit terminé avant de vérifier l'authentification
  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="text-center">
          <div className="mb-4 inline-block h-12 w-12 animate-spin rounded-full border-4 border-emerald-600 border-t-transparent"></div>
          <p className="text-slate-600 dark:text-slate-300">
            Loading...
          </p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (role && role === "admin" && !isAdmin()) {
    // console.log("❌ ProtectedRoute - Pas admin → Redirection /", {
    //   requiredRole: role,
    //   userRole: user?.role,
    //   isAdminCheck: isAdmin(),
    // });
    return <Navigate to="/" replace />;
  }

  // console.log("✅ ProtectedRoute - Accès autorisé");
  return <Outlet />;
}
